var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardModalDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 58,
    height: 58,
    rx: 29,
    fill: "#F97066"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1648_15697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2499 23H33.9249C33.7509 22.1536 33.2903 21.393 32.6209 20.8465C31.9515 20.3001 31.1141 20.0011 30.2499 20H28.7499C27.8858 20.0011 27.0484 20.3001 26.379 20.8465C25.7096 21.393 25.249 22.1536 25.0749 23H22.7499C22.551 23 22.3603 23.079 22.2196 23.2197C22.079 23.3603 21.9999 23.5511 21.9999 23.75C21.9999 23.9489 22.079 24.1397 22.2196 24.2803C22.3603 24.421 22.551 24.5 22.7499 24.5H23.4999V34.25C23.5011 35.2442 23.8966 36.1973 24.5996 36.9003C25.3026 37.6033 26.2557 37.9988 27.2499 38H31.7499C32.7441 37.9988 33.6973 37.6033 34.4003 36.9003C35.1033 36.1973 35.4987 35.2442 35.4999 34.25V24.5H36.2499C36.4489 24.5 36.6396 24.421 36.7803 24.2803C36.9209 24.1397 36.9999 23.9489 36.9999 23.75C36.9999 23.5511 36.9209 23.3603 36.7803 23.2197C36.6396 23.079 36.4489 23 36.2499 23ZM28.7499 21.5H30.2499C30.7151 21.5006 31.1688 21.645 31.5486 21.9136C31.9285 22.1821 32.216 22.5616 32.3717 23H26.6282C26.7839 22.5616 27.0714 22.1821 27.4512 21.9136C27.8311 21.645 28.2847 21.5006 28.7499 21.5ZM33.9999 34.25C33.9999 34.8467 33.7629 35.419 33.3409 35.841C32.919 36.2629 32.3467 36.5 31.7499 36.5H27.2499C26.6532 36.5 26.0809 36.2629 25.6589 35.841C25.237 35.419 24.9999 34.8467 24.9999 34.25V24.5H33.9999V34.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 33.5C28.1989 33.5 28.3897 33.421 28.5303 33.2803C28.671 33.1397 28.75 32.9489 28.75 32.75V28.25C28.75 28.0511 28.671 27.8603 28.5303 27.7197C28.3897 27.579 28.1989 27.5 28 27.5C27.8011 27.5 27.6103 27.579 27.4697 27.7197C27.329 27.8603 27.25 28.0511 27.25 28.25V32.75C27.25 32.9489 27.329 33.1397 27.4697 33.2803C27.6103 33.421 27.8011 33.5 28 33.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9999 33.5C31.1988 33.5 31.3896 33.421 31.5302 33.2803C31.6709 33.1397 31.7499 32.9489 31.7499 32.75V28.25C31.7499 28.0511 31.6709 27.8603 31.5302 27.7197C31.3896 27.579 31.1988 27.5 30.9999 27.5C30.801 27.5 30.6102 27.579 30.4696 27.7197C30.3289 27.8603 30.2499 28.0511 30.2499 28.25V32.75C30.2499 32.9489 30.3289 33.1397 30.4696 33.2803C30.6102 33.421 30.801 33.5 30.9999 33.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1648_15697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(20.5 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardModalDelete);
export default __webpack_public_path__ + "static/media/dashboard-modal-delete.a85f2253aca7cf5fb0a55ba8703c3550.svg";
export { ForwardRef as ReactComponent };